import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-kamal',
  templateUrl: './events-kamal.component.html',
  styleUrls: ['./events-kamal.component.scss'],
})
export class EventsKamalComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/kamal/1.jpg',
      thumbnail: 'assets/img/school/events/kamal/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/2.jpg',
      thumbnail: 'assets/img/school/events/kamal/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/3.jpg',
      thumbnail: 'assets/img/school/events/kamal/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/4.jpg',
      thumbnail: 'assets/img/school/events/kamal/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/5.jpg',
      thumbnail: 'assets/img/school/events/kamal/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/6.jpg',
      thumbnail: 'assets/img/school/events/kamal/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/kamal/7.jpg',
      thumbnail: 'assets/img/school/events/kamal/7.jpg',
      alt: 'Image 01',
    },
  ];
}
